import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  public isValidResponse(response: any) {
    return (
      response &&
      response.status !== 0 &&
      response.status !== 400 &&
      _.has(response, 'value')
    );
  }
}
